import { CounterBadgeAppearance as FluentCounterBadgeAppearance, CounterBadgeColor as FluentCounterBadgeColor, CounterBadgeShape as FluentCounterBadgeShape, CounterBadgeSize as FluentCounterBadgeSize } from "@fluentui/web-components";
/**
 * Appearances for {@link CounterBadge}.
 * @public
 */
export const CounterBadgeAppearances = {
    ...FluentCounterBadgeAppearance
};
/**
 * Colors for {@link CounterBadge}.
 * @public
 */
export const CounterBadgeColors = {
    ...FluentCounterBadgeColor
};
/**
 * Shapes for {@link CounterBadge}.
 * @public
 */
export const CounterBadgeShapes = {
    ...FluentCounterBadgeShape
};
/**
 * Sizes for {@link CounterBadge}.
 * @public
 */
export const CounterBadgeSizes = {
    ...FluentCounterBadgeSize
};
//# sourceMappingURL=counter-badge.options.js.map